import './SuccessServiceStep.scss';

import AppContainer from "../../../commons/containers/AppContainer";
import AppLinkButton from "../../../commons/buttons/AppLinkButton";
import success from '../../../assets/images/sucesso.png';

function SuccessServiceStep({ closeModal }) {
  return (
    <AppContainer>
      <div className="success-step">
        <div className="success-step__icon">
          <img src={success} alt="Sucesso" />
        </div>

        <h1 className="success-step__title">Parabéns!</h1>

        <p className="success-step__subtitle">
          Seu serviço foi salvo com sucesso. Agora você pode aproveitar as funcionalidades
          disponíveis para otimizar seu atendimento e gestão.
        </p>

        <div className="success-step__actions">
          <AppLinkButton onClick={closeModal} width="100%" name="Fechar" />
        </div>
      </div>
    </AppContainer>
  );
}

export default SuccessServiceStep;